import { render, staticRenderFns } from "./PantallaSurtirSinFolio.vue?vue&type=template&id=4cccf144&lang=true&"
import script from "./PantallaSurtirSinFolio.vue?vue&type=script&lang=js&"
export * from "./PantallaSurtirSinFolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports